import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FilePlus, Receipt } from 'lucide-react';
import { MPRTab } from './stores/MPRTab';
import { VendorInvoicesTab } from './stores/VendorInvoicesTab';

// This page used to be a 12-tab "Store & Inventory" surface. Every tab except
// MPR and Vendor Invoices called the deleted stores.py / stores_fifo.py
// endpoints (dead since the EPC Project-entity removal) and rendered
// permanently empty — those were removed. Purchase Orders was also dropped:
// /app/procurement already has a fuller PO tab (bulk import, multi-line
// items) hitting the same /po endpoints, so keeping a thinner duplicate here
// added nothing. MPR stays — Procurement.jsx's own MPR panel is read-only by
// design ("MPRs are raised in Store & Inventory → MPR"), so this is the only
// place an MPR can actually be created.
const TABS = [
  { id: 'mpr', label: 'MPR', icon: FilePlus },
  { id: 'vendor-invoices', label: 'Vendor Invoices', icon: Receipt },
];

export default function Stores() {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlTab = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(urlTab || 'mpr');

  useEffect(() => {
    const t = searchParams.get('tab');
    if (t && t !== activeTab) {
      setActiveTab(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const changeTab = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <div className="flex-1 min-h-0 flex flex-col">
      <div className="bg-white border-b px-6 py-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Store & Inventory</h1>
          <p className="text-sm text-gray-500 mt-1">Material requisitions and vendor invoicing</p>
        </div>
        <div className="flex gap-1 mt-4 overflow-x-auto pb-1">
          {TABS.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => changeTab(tab.id)}
                data-testid={`stores-tab-${tab.id}`}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                  activeTab === tab.id
                    ? 'bg-[#1F7A6E] text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-6">
        {activeTab === 'mpr' && <MPRTab />}
        {activeTab === 'vendor-invoices' && <VendorInvoicesTab />}
      </div>
    </div>
  );
}
